/* ==========================================================================
   FreezeCap™ — fc-underhood.liquid wiring (extracted from inline in v6.28)
   --------------------------------------------------------------------------
   Hotspot panels for the annotated under-hood section. Each frame is
   identified by `[data-fc-underhood-frame]`; clicking a hotspot toggles
   its panel and closes any siblings. Outside-click and Escape close all.
   ========================================================================== */
(function () {
  function wire(frame) {
    var hotspots = frame.querySelectorAll('.hotspot');

    function closeAll(except) {
      hotspots.forEach(function (h) {
        if (h !== except) {
          h.classList.remove('is-open');
          h.setAttribute('aria-expanded', 'false');
        }
      });
    }

    hotspots.forEach(function (hot) {
      hot.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = hot.classList.toggle('is-open');
        hot.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) closeAll(hot);
      });
      hot.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          hot.classList.remove('is-open');
          hot.setAttribute('aria-expanded', 'false');
        }
      });
    });

    /* Close all when the click lands outside this frame */
    document.addEventListener('click', function (e) {
      if (!frame.contains(e.target)) closeAll(null);
    });
  }

  function init() {
    document.querySelectorAll('[data-fc-underhood-frame]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
